// Split Feature (standard/refresh tabs). Root element: [data-sw-split] (one per section).
// SW: tabs and video playback work without GSAP; GSAP (when loaded) only adds the crossfade and step stagger.
// The active video plays while the section is on screen, with a caught play(), up to 2 retries, and resume after
// tab or app switches and back/forward cache.
(function () {
  if (window.__swSplitFeatureLoaded) return;
  window.__swSplitFeatureLoaded = true;

  var SELECTOR = '[data-sw-split]';
  var instances = [];

  function init(section) {
    if (section.dataset.swInit) return; // guard against double init
    section.dataset.swInit = '1';

    var tabs       = section.querySelectorAll('.sw-split__tab');
    var panels     = section.querySelectorAll('.sw-split__panel');
    var videoWraps = section.querySelectorAll('.sw-split__video-wrap');

    // Reduced motion: no autoplay on scroll, no crossfade/stagger tweens
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inView = false;
    var ctx = null;

    function getCtx() {
      if (!ctx && window.gsap) ctx = gsap.context(function () {}, section);
      return ctx;
    }

    function activeVideo() {
      var activeWrap = section.querySelector('.sw-split__video-wrap.is-active');
      return activeWrap ? activeWrap.querySelector('video') : null;
    }

    function safePlay(video, tries) {
      if (!video) return;
      tries = tries || 0;
      clearTimeout(video._swRetry);
      if (video.readyState < 2 && video.networkState !== 2) video.load();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      if (tries >= 2) return;
      video._swRetry = setTimeout(function () {
        if (video.paused && inView && !document.hidden && video === activeVideo()) safePlay(video, tries + 1);
      }, 2500);
    }

    function pauseAll(except) {
      section.querySelectorAll('.sw-split__video').forEach(function (v) {
        if (v === except) return;
        clearTimeout(v._swRetry);
        v.pause();
      });
    }

    // ── Play the active video while the section is on screen ──
    var io = null;
    if (!reduceMotion && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) safePlay(activeVideo());
        else pauseAll();
      }, { rootMargin: '-10% 0px -10% 0px' });
      io.observe(section);
    }

    function resume() {
      if (!reduceMotion && inView && !document.hidden) safePlay(activeVideo());
    }
    function onPageShow(event) { if (event.persisted) resume(); }
    document.addEventListener('visibilitychange', resume);
    window.addEventListener('pageshow', onPageShow);

    // ── Tab switching ──
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;
        if (tab.classList.contains('is-active')) return;

        // Update tab states
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var context = reduceMotion ? null : getCtx();

        if (!context) {
          var nextVideo = null;
          videoWraps.forEach(function (wrap) {
            var isTarget = wrap.classList.contains('sw-split__video-wrap--' + target);
            wrap.classList.toggle('is-active', isTarget);
            if (isTarget) nextVideo = wrap.querySelector('video');
          });
          panels.forEach(function (panel) { panel.hidden = panel.dataset.panel !== target; });
          pauseAll(nextVideo);
          if (!reduceMotion && nextVideo) { nextVideo.currentTime = 0; safePlay(nextVideo); }
          return;
        }

        // Tweens run inside the context so they are reverted on section unload
        context.add(function () {
          // Crossfade videos
          videoWraps.forEach(function (wrap) {
            var video = wrap.querySelector('video');
            if (wrap.classList.contains('sw-split__video-wrap--' + target)) {
              gsap.to(wrap, {
                opacity: 1, duration: 0.5, ease: 'power2.inOut',
                onStart: function () {
                  wrap.classList.add('is-active');
                  if (video) { video.currentTime = 0; safePlay(video); }
                }
              });
            } else {
              gsap.to(wrap, {
                opacity: 0, duration: 0.4, ease: 'power2.inOut',
                onComplete: function () {
                  wrap.classList.remove('is-active');
                  if (video) { clearTimeout(video._swRetry); video.pause(); }
                }
              });
            }
          });

          // Swap panels
          panels.forEach(function (panel) {
            if (panel.dataset.panel === target) {
              panel.hidden = false;
              var steps = panel.querySelectorAll('.sw-split__step');
              gsap.fromTo(steps,
                { y: 20, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.45, ease: 'power2.out', stagger: 0.1 }
              );
            } else {
              panel.hidden = true;
            }
          });
        });
      });
    });

    instances.push({
      el: section,
      destroy: function () {
        if (io) io.disconnect();
        document.removeEventListener('visibilitychange', resume);
        window.removeEventListener('pageshow', onPageShow);
        pauseAll();
        if (ctx) ctx.revert();
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (inst) {
      if (e.target.contains(inst.el)) { inst.destroy(); return false; }
      return true;
    });
  });

  initAll();
  // GSAP is optional here (crossfade only)
  if (window.swGsap) swGsap.load();
})();
